import app from "./app";

document.getElementById('app').innerHTML = app;